if (module.hot) {
  module.hot.accept();
}

/**
 * Polyfills
 */

// initialize prefersColorScheme (applies the current OS color scheme, if available)
import cssHasPseudo from 'css-has-pseudo/browser';
cssHasPseudo(document);

/**
 * Modules
 */

import './modules/ToggleTarget';
import './modules/Scroller';
import './modules/Portfolio';
import './modules/Slideshow';
import './modules/CookieBar';
import './modules/HeroImage';

/**
 * Print
 * 
 * Make sure image are visible when printing
 */

window.onbeforeprint = () => {
  const imgs = document.querySelectorAll('img');
  imgs.forEach(img => img.removeAttribute('loading') )
};